export default {
  common: {
    MOP: 'Pide y Retira',
  },
}
